import { render } from "./hcaptchaWidget.vue?vue&type=template&id=0ffac7df"
import script from "./hcaptchaWidget.vue?vue&type=script&lang=js"
export * from "./hcaptchaWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__